export default __webpack_public_path__ + "static/media/Snd3.54c8466b.mp3";